import { useLocation } from "react-router-dom";
import { getSeoForPath } from "../assets/seoConfig";
import { Seo } from "./Seo";

export function RouteSeo() {
  const { pathname } = useLocation();
  const config = getSeoForPath(pathname);
  return (
    <Seo
      title={config.title}
      description={config.description}
      path={config.path}
      noindex={config.noindex}
      jsonLd={config.jsonLd}
    />
  );
}
